
import ChannelService from './ChannelService';

export { default } from './ChannelService';
export const channelService = new ChannelService();